/* eslint-disable consistent-return */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid/Grid";
import Button from "@material-ui/core/Button/Button";
import withWidth from "@material-ui/core/withWidth/withWidth";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import Typography from "@material-ui/core/Typography/Typography";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  ConfigurateDesignerImageIcon,
  ConfigurateDesignerTextIcon,
} from "../../../../../Icons";

const styles = (theme) => ({
  designerHeading: {
    marginBottom: theme.spacing(1),
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "inline",
    },
  },
  menuButton: {
    fontSize: 14,
    margin: `${theme.spacing(1)}px 0px`,
    [theme.breakpoints.up("sm")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: 16,
    },

    borderRadius: 0,
    border: `1px solid`,
    borderColor: theme.palette.configBtn.borderColor,
    boxShadow: "none",
    fontWeight: "bold",
    textTransform: "unset",
    background: theme.palette.configBtn.light,
    color: theme.palette.configBtn.lightText,

    "& .material-icons": {
      color: theme.palette.configBtn.lightText,
    },
    "&:hover": {
      background: "#F2F2F2",
      color: theme.palette.configBtn.lightText,
      boxShadow: "none",
    },
    "&:focus, &:active": {
      background: "#C9C9C9",
      color: theme.palette.configBtn.pressedText,
      boxShadow: "none",
    },
  },
  buttonIcon: {
    paddingRight: theme.layout.buttonIcon.paddingRight,
  },
  radioHeading: {
    //  fontWeight: 'bold',
  },
  radioFormControl: {
    fontSize: 14,
    "& .MuiButtonBase-root": {
      padding: "3px 9px", // breaks styling in chrome!
      color: theme.layout.radio.color,
    },
    "& .MuiTypography-root": {
      fontSize: 14,
    },
  },
  radioGroup: {
    marginBottom: 9,
  },
});

const VG = "VG";
const VGM = "VGM";
const DG = "DG";
const LG = "LG";
const DD = "DD";
const printMap = new Map();
printMap.set("VG", VG);
printMap.set("VGM", VGM);
printMap.set("XL", DG);
printMap.set("DD", DD);
printMap.set("DDM", DD);
printMap.set("LG", LG);
const getPrint = (type) => {
  if (!type) return DG;
  const input = type.toUpperCase();
  if (printMap.has(input)) return printMap.get(input);
  return DG;
};

class ElementMenu extends React.Component {
  static propTypes = {
    onAddTextClick: PropTypes.func,
    onAddImageClick: PropTypes.func,
    onImageFileSelected: PropTypes.func,
    boxed: PropTypes.bool,
    classes: PropTypes.object,
    width: PropTypes.string,
    components: PropTypes.shape({
      ButtonContainer: PropTypes.elementType.isRequired,
    }).isRequired,
    hasLastEditedDesignArea: PropTypes.bool,
    onAddImageClickFunc: PropTypes.func,
    selectedDesignArea: PropTypes.object,
  };

  static defaultProps = {
    boxed: false,
    classes: {},
    components: {
      ButtonContainer: Grid,
    },
  };

  constructor(props) {
    super(props);
    this.callToActionRef = React.createRef();
    this.state = {
      selectedConcreteProductionMethod: null,
      selectedConcreteDesignArea: null,
      _renderedDesignAreas: <></>,
    };
  }

  handleProductionMethodChangeFunc = (event) => {
    const data = JSON.parse(event.target.value || "{}");
    const { name, value } = data;
    // console.log('--->handleProductionMethodChangeFunc', { name, value }, { selectedConcreteProductionMethod: name });
    const { handleProductionMethodChange } = this.props;
    this.setState({ selectedConcreteProductionMethod: name });
    handleProductionMethodChange(value);
  };

  renderDesignAreas = (
    selectedProductionMethod,
    selectedConcreteProductionMethod,
    selectedConcreteDesignArea
  ) => {
    const { selectedDesignArea: designArea, classes } = this.props;
    if (!designArea.designProductionMethods) return;
    if (designArea.designProductionMethods.length > 0) {
      let currentPrintType = null;
      let displayPrintType = false;

      const baseConfig = { count: 0, label: "" };
      const methodCount = {
        LG: { ...baseConfig, sizes: {} },
        DG: { ...baseConfig, sizes: {} },
        VG: { ...baseConfig, sizes: {} },
        DD: { ...baseConfig, sizes: {} },
      };
      const fullSizeList = {};
      designArea.designProductionMethods.forEach((method) => {
        if (!method) return;
        const { identifier, title } = method;
        const methodOfMap = methodCount[getPrint(identifier)];

        if (currentPrintType && !displayPrintType) {
          if (methodOfMap !== currentPrintType) displayPrintType = true;
        } else currentPrintType = methodOfMap;

        methodOfMap.count += 1;
        if (methodOfMap.label.length < 1) methodOfMap.label = title;

        const sizeIdenfifier = `${method.height}x${method.width}`;
        if (!methodOfMap.sizes[sizeIdenfifier]) {
          methodOfMap.sizes[sizeIdenfifier] = {
            title: `${method.height} x ${method.width} mm`,
            width: method.width,
            height: method.height,
            mapTo: identifier,
          };
        }
        if (!fullSizeList[sizeIdenfifier]) fullSizeList[sizeIdenfifier] = [];
        fullSizeList[sizeIdenfifier].push(identifier);
      });

      const renderMethodCheckbox = (
        method,
        name,
        selectedConcreteProductionMethod,
        selectedProductionMethod
      ) => {
        /* console.log('-> renderMethodCheckbox', {
            name, selectedProductionMethod, selectedConcreteProductionMethod, selectedConcreteDesignArea,
          }); */
        const { count, sizes, label } = method;
        const sizeKeys = Object.keys(sizes);

        if (count > 0) {
          let value = sizes[sizeKeys[0]].mapTo;
          if (count > 1) {
            const found = sizeKeys.find(
              (key) => key.mapTo === selectedProductionMethod
            );
            if (found) value = found.mapTo;
          }
          return (
            <FormControlLabel
              checked={selectedConcreteProductionMethod === name}
              className={classes.radioFormControl}
              key={name}
              value={JSON.stringify({ name, value })}
              label={label}
              control={<Radio />}
            />
          );
        }
      };

      const renderPrintAreaCheckbox = (
        size,
        sizeList,
        selectedMethod,
        selectedProductionMethod
      ) => {
        /*  console.log('-> renderPrintAreaCheckbox', {
            size, sizeList, selectedMethod, selectedProductionMethod, print: getPrint(selectedProductionMethod),
          }); */
        const { sizes } = selectedMethod;

        const value = sizes[size]?.mapTo;
        const name = getPrint(selectedProductionMethod);
        return (
          <FormControlLabel
            checked={sizeList.find((i) => i === selectedProductionMethod)}
            className={classes.radioFormControl}
            key={size}
            value={JSON.stringify({ name, value })}
            disabled={!sizes[size]}
            label={size}
            control={<Radio />}
          />
        );
      };
      const methodOfMap = methodCount[getPrint(selectedProductionMethod)];
      // console.log({ methodOfMap, fullSizeList });

      return (
        <>
          {displayPrintType && (
            <>
              <Typography className={classes.radioHeading} variant="body1">
                {t("addVisualElement.selectPrintType")}
              </Typography>
              <RadioGroup
                className={classes.radioGroup}
                aria-label="designProductionMethods"
                name="designProductionMethods"
                value={selectedConcreteProductionMethod}
                onChange={this.handleProductionMethodChangeFunc}
              >
                {Object.keys(methodCount).map((key) =>
                  renderMethodCheckbox(
                    methodCount[key],
                    key,
                    selectedConcreteProductionMethod,
                    selectedProductionMethod
                  )
                )}
              </RadioGroup>
            </>
          )}
          {Object.keys(fullSizeList).length > 1 && (
            <>
              <Typography className={classes.radioHeading} variant="body1">
                {t("addVisualElement.selectPrintArea")}
              </Typography>
              <RadioGroup
                className={classes.radioGroup}
                aria-label="designProductionArea"
                name="designProductionAreas"
                value={selectedConcreteDesignArea}
                onChange={this.handleProductionMethodChangeFunc}
              >
                {Object.keys(fullSizeList).map((key) =>
                  renderPrintAreaCheckbox(
                    key,
                    fullSizeList[key],
                    methodOfMap,
                    selectedProductionMethod
                  )
                )}
              </RadioGroup>
            </>
          )}
        </>
      );
    }
    return <div />;
  };

  // eslint-disable-next-line react/sort-comp
  componentWillReceiveProps(props) {
    const { selectedProductionMethod, selectedDesignArea } = props;
    if (selectedProductionMethod !== this.props.selectedProductionMethod) {
      let selectedConcreteDesignArea = null;
      if (!selectedDesignArea) return;
      if (!selectedDesignArea.designProductionMethods) return;
      selectedDesignArea.designProductionMethods.some((method) => {
        if (!method) return false;
        if (method.identifier === selectedProductionMethod) {
          const dASizeIdenfifier = `${method.height}x${method.width}`;
          selectedConcreteDesignArea = dASizeIdenfifier;
          return true;
        }
        return false;
      });
      const { selectedConcreteProductionMethod } = this.state;
      this.setState({
        selectedConcreteDesignArea,
        _renderedDesignAreas: this.renderDesignAreas(
          selectedProductionMethod,
          selectedConcreteProductionMethod ||
            getPrint(selectedProductionMethod),
          selectedConcreteDesignArea
        ),
      });
    }
  }

  render() {
    const { classes, onAddTextClick, onAddImageClickFunc } = this.props;
    const { _renderedDesignAreas } = this.state;
    // console.log('selectedProductionMethod', this.props.selectedProductionMethod);
    return (
      <>
        <Typography variant="body1" className={classes.designerHeading}>
          <b>{t("addVisualElement.designerHeading")}</b>
        </Typography>

        {_renderedDesignAreas}
        <Button
          className={classes.menuButton}
          variant="contained"
          fullWidth
          size="medium"
          onClick={onAddImageClickFunc}
        >
          <ConfigurateDesignerImageIcon className={classes.buttonIcon} />
          {t("addVisualElement.image")}
        </Button>
        <Button
          className={classes.menuButton}
          variant="contained"
          fullWidth
          size="medium"
          onClick={onAddTextClick}
        >
          <ConfigurateDesignerTextIcon className={classes.buttonIcon} />
          {t("addVisualElement.text")}
        </Button>
      </>
    );
  }
}

export default withWidth({ initialWidth: "lg" })(
  withStyles(styles, { name: "ElementMenu" })(ElementMenu)
);
